import { Pipe, PipeTransform } from '@angular/core';

import { formattedErrors, getErrorMessage } from '@assess/browser/form-validation';

@Pipe({ name: 'formatError' })
export class FormatErrorPipe implements PipeTransform {
  transform(err: any, controlName?: string) {
    return getErrorMessage(formattedErrors, err, controlName);
  }
}
